import { Button } from "@ds/react";
import styled from "styled-components/macro";

export const CardRadio = styled.div(
  ({ theme: { spacing, breakpoint }, size }) => ({
    display: "flex",
    flexDirection: size === "normal" ? "column" : "row",
    gap: size === "normal" ? spacing.stack["2xs"] : spacing.stack["3xs"],

    [breakpoint.xl()]: {
      flexDirection: "row",
      justifyContent: "flex-start",
      gap: size === "normal" ? spacing.stack.sm : spacing.stack["2xs"],
    },

    "> button": {
      flexGrow: 1,
      width: "100%",
    },
  })
);

export const RadioButton = styled.div(({ theme, selected }) => ({
  borderRadius: theme.border.radius.circular,
  width: theme.spacing.inset.sm,
  height: theme.spacing.inset.sm,
  marginRight: "10px",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  border: selected
    ? `2px solid ${theme.color.neutral["08"]}`
    : `2px solid ${theme.color.neutral["04"]}`,

  "::before": {
    content: "''",
    width: "9px",
    height: "9px",
    border: "none",
    borderRadius: theme.border.radius.circular,
    background: theme.color.neutral["08"],
  },
}));

export const CheckButton = styled(Button)(({ theme, selected, size }) => ({
  "> span": {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: size === "normal" ? "center" : "flex-start",
  },

  margin: 0,
  paddingInline: "22px",
  height: size === "normal" ? "5.75rem" : "4rem",
  border: selected
    ? `1px solid ${theme.color.brandPrimary.light}`
    : `1px solid ${theme.color.neutral["04"]}`,
  borderRadius: "4px",
  backgroundColor: selected
    ? theme.color.brandPrimary.medium
    : theme.color.neutral["08"],
  color: selected ? theme.color.neutral["08"] : theme.color.brandPrimary.medium,

  ":hover": {
    backgroundColor: selected
      ? theme.color.brandPrimary.medium
      : theme.color.neutral["08"],
    color: selected
      ? theme.color.neutral["08"]
      : theme.color.brandPrimary.medium,
  },

  svg: {
    fill: selected
      ? theme.color.neutral["08"]
      : theme.color.brandPrimary.medium,
    marginLeft: theme.spacing.inline.sm,
    width: theme.icon.size["3xl"],
    height: theme.icon.size["3xl"],
  },

  div: {
    div: {
      backgroundColor: selected
        ? theme.color.brandPrimary.medium
        : "transparent",
      "::before": {
        display: selected ? "block" : "none",
      },
    },
  },

  [theme.breakpoint.lg()]: {
    width: "17rem",
  },
}));
